import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';



const UserCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const generatedUserName = `${firstName.toLowerCase()}_${lastName.toLowerCase()}`;
        // Limit the username to a maximum length of 15 characters
        const limitedUserName = generatedUserName.slice(0, 15);
        setUserName(limitedUserName);

    }, [firstName, lastName]);

    const clearForm = () => {
        setFirstName("");
        setLastName("");
        setUserName("");
        setContactNumber("");
        setEmail("");
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        // if (!isSubmit) {
        //     return;
        // }

        if (!firstName) {
            setErrorMessage('First Name is required !');
            // setIsSubmit(false);
            setIsLoading(false);
            return;
        }

        if (!lastName) {
            setErrorMessage('Last Name is required !');
            //  setIsSubmit(false);
            setIsLoading(false);
            return;

        }

        if (!contactNumber) {
            setErrorMessage('Contact Number is required !');
            // setIsSubmit(false);
            setIsLoading(false);
            return;

        }

        if (!email) {
            setErrorMessage('Email is required !');
            //setIsSubmit(false);
            setIsLoading(false);
            return;

        }



        const CreateData = {
            FirstName: firstName,
            LastName: lastName,
            UserName: userName,
            Email: email,
            ContactNumber: contactNumber,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('UserApi', CreateData, token)
            .then((response) => {
                console.log('User Created success:', response);
                setSuccessMessage("User Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/UserIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('User Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>USER CREATE</h6>

                        <Tooltip title="Exit">
                            <Link to="/UserIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                First Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                type="text" placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                type="text" placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                User Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                type="text" placeholder="Enter User Name"
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Contact Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text" placeholder="Enter Contact Number"
                                maxLength={15}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Email
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="text" placeholder="Enter Email"
                                maxLength={40}
                            />
                        </div>

                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default UserCreate;

